import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
    faMapMarkerAlt, 
    faPhone, 
    faEnvelope, 
    faClock,
    /*faShippingFast,
    faTruck,
    faStore,
    faCreditCard,
    faUniversity,
    faMoneyBillWave,
    faMobileAlt,
    faShieldAlt,
    faLock,
    faUndo,*/
    faPaperPlane,
    faCookieBite  
} from '@fortawesome/free-solid-svg-icons';
import { 
    faFacebookF, 
    faInstagram, 
    faTiktok, 
    faLinkedinIn,
    /* faCcPaypal,
    faCcVisa,
    faCcMastercard,
    faCcApplePay,
    faCcAmazonPay */
} from '@fortawesome/free-brands-svg-icons';

import './footer.scss';

const Footer = ({ onOpenCookieModal }) => {
    const [email, setEmail] = useState('');


    const handleNewsletterSubmit = (e) => {
        e.preventDefault();
        console.log('Email iscritta:', email);
        setEmail('');
        alert('Grazie per esserti iscritto alla nostra newsletter!');
    };


    const socialLinks = [
            {
                platform: 'facebook',
                url: 'http://localhost:3000/',
                icon: faFacebookF,
                label: 'Seguici su Facebook'
            },
            {
                platform: 'instagram',
                url: 'http://localhost:3000/',
                icon: faInstagram,
                label: 'Seguici su Instagram'
            },
            {
                platform: 'tiktok',
                url: 'http://localhost:3000/',
                icon: faTiktok,
                label: 'Seguici su TikTok'
            },
            {
                platform: 'linkedin',
                url: 'http://localhost:3000/',
                icon: faLinkedinIn,
                label: 'Seguici su LinkedIn'
            }
        ];

    return (
        <footer className="footer">
            <div className="container">
                {/* Contenuto principale del footer */}
                <div className="footer-content">

                    {/* Sezione Informazioni */}
                    <div className="footer-section">
                        <h3>MO...STO DIVINO</h3>
                        <p>
                        Il tuo negozio online di fiducia dal 2025. Offriamo prodotti di qualità 
                        al miglior prezzo garantito con consegna in tutta Italia.
                        </p>
                        <div className="contact-info">
                            <p><FontAwesomeIcon icon={faMapMarkerAlt} className="icon"/><i className="fas fa-map-marker-alt"></i>C.so Marrucino 147, 66100 Chieti CH</p>
                            <p><FontAwesomeIcon icon={faPhone} className="icon"/><i className="fas fa-phone"></i>+39 366 40 11 401</p>
                            <p><FontAwesomeIcon icon={faEnvelope} className="icon"/><i className="fas fa-envelope"></i>info@mostodivino.it</p>
                            <p><FontAwesomeIcon icon={faClock} className="icon"/><i className="fas fa-clock"></i>Lun-Ven: 9:00-18:00</p>
                        </div>        
                        <div className="trust-pilot">        
                            <div className="trust-score">
                                <span className="stars">★★★★★</span>
                                <span>4.8/5 su Trustpilot</span>
                            </div>    
                        </div>
                    </div>

                    {/* Sezione Categorie */}
                    <div className="footer-section">
                        <h3>Categorie</h3>
                        <ul>
                            <li><a href="/elettronica">Scatole di vino</a></li>
                            <li><a href="/abbigliamento">Utensili da sommelier</a></li>
                            <li><a href="/casa-e-giardino">Cantine frigo per lo stoccaggio</a></li>
                            <li><a href="/sport">Cantine frigo per l'invecchiamento</a></li>
                            <li><a href="/bellezza">Birre artigianali e distillati</a></li>
                            <li><a href="/libri">Prodotti regionali artigianali</a></li>
                        </ul>
                    </div>           
                        
                    {/* Sezione Servizio Clienti */}
                    <div className="footer-section">
                        <h3>Servizio Clienti</h3>
                        <ul>
                            <li><a href="/contatti">Contattaci</a></li>
                            <li><a href="/spedizioni">Spedizioni e consegne</a></li>
                            <li><a href="/resil">Resi e rimborsi</a></li>
                            <li><a href="/faq">FAQ</a></li>
                            <li><a href="/guida-taglie">Guida alle taglie</a></li>
                            <li><a href="/tracking">Traccia il tuo ordine</a></li>
                        </ul>
                    </div> 

                    {/* Sezione Azienda */}
                    <div className="footer-section">
                        <h3>Azienda</h3>
                        <ul>
                            <li><a href="/chi-siamo">Chi siamo</a></li>
                            <li><a href="/lavora-con-noi">Lavora con noi</a></li>
                            <li><a href="/privacy">Privacy policy</a></li>
                            <li><a href="/termini-condizioni">Termini e condizioni</a></li>
                            <li><a href="/cookie-policy">Cookie policy</a></li>
                            <li>
                                <button 
                                    onClick={onOpenCookieModal}
                                    className="cookie-manage-btn"
                                >
                                    <FontAwesomeIcon icon={faCookieBite} />
                                    Gestione cookie
                                </button>
                            </li>
                        </ul>
                    </div>

                     {/* Sezione Newsletter e Social */}
                    <div className="footer-section">
                        <h3>Rimani aggiornato</h3>
                        <p>
                        Iscriviti alla newsletter per ricevere offerte esclusive, 
                        anticipazioni sui nuovi prodotti.
                        </p>
                        <form className="newsletter-form" onSubmit={handleNewsletterSubmit}>
                            <input
                                type="email"
                                placeholder="La tua email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                aria-label="Indirizzo email per la newsletter"
                            />
                            <button type="submit" aria-label="Iscriviti alla newsletter">
                                <FontAwesomeIcon icon={faPaperPlane} />
                                Iscriviti
                            </button>
                        </form>
                        
                        <div className="social-links">
                            {socialLinks.map((social) => (
                                <a  key={social.platform}
                                    href={social.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="social-links"
                                    aria-label={social.label}
                                >
                                <FontAwesomeIcon icon={social.icon} />    
                                </a>
                            ))}
                        </div>

                        {/* <div className="payment-methods">
                            <h4>Pagamenti Sicuri</h4>
                            <div className="payment-icons">
                                <span title="Carta di Credito"><i className="fas fa-credit-card"></i></span>
                                <span title="PayPal"><i className="fab fa-cc-paypal"></i></span>
                                <span title="Satispay"><i className="fas fa-mobile-alt"></i></span>
                                <span title="Bonifico Bancario"><i className="fas fa-university"></i></span>
                                <span title="Contrassegno"><i className="fas fa-money-bill-wave"></i></span>
                            </div>    
                        </div>    
                        <div className="shipping-info">
                            <h4>Consegna in Italia</h4>
                            <div className="shipping-icons">
                                <span title="Consegna Express 24h"><i className="fas fa-shipping-fast"></i></span>
                                <span title="Consegna Standard"><i className="fas fa-truck"></i></span>
                                <span title="Ritiro in Sede"><i className="fas fa-store"></i></span>
                            </div>    
                        </div> */}        
                    </div>            
                </div>

                {/* Sezione certificazioni e sicurezza */}
                <div className="certifications">                 
                    <div className="certification-badges">
                        <div className="badge"><i className="fas fa-shield-alt"></i><span>Pagamento Sicuro SSL</span></div>
                        <div className="badge"><i className="fas fa-lock"></i><span>Dati Protetti</span></div>
                        <div className="badge"><i className="fas fa-truck"></i><span>Spedizione 24/48h</span></div>
                        <div className="badge"><i className="fas fa-undo"></i><span>Reso Gratuito 30gg</span></div>
                    </div>       
                </div>

                {/* Sezione legale */}
                <div className="footer-bottom">
                    <div className="footer-bottom__content">
                        <div className="copyright">
                            <p>
                                &copy; {new Date().getFullYear()} Il Tuo E-commerce S.r.l. - 
                                P.IVA 12345678901 - REA RM-1234567 - 
                                Capitale Sociale € 5.000,00 i.v.
                            </p>
                        </div>
                        <div className="footer-bottom__links">
                            <a href="/privacy">Privacy Policy</a>
                            <a href="/cookie-policy">Cookie Policy</a>
                            <a href="/termini-condizioni">Termini e Condizioni</a>
                            <a href="/vendita">Condizioni di Vendita</a>
                            <a href="/informazioni-legali">Informazioni Legali</a>
                            <button 
                                onClick={onOpenCookieModal}
                                className="cookie-manage-link"
                            >
                                Gestione Cookie
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;        
